import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const isUserOnRootDomain = window.location.pathname === '/' || window.location.pathname === '';

// Check the referrer. If we're not arriving at CPS2 from the hub we punt the user back to the hub before they can continue.
// This makes the return to hub check more difficult to pass
if (isUserOnRootDomain && document.referrer.indexOf(environment.HUB_ENDPOINT) === -1) {
  const lang = new URLSearchParams(window.location.search).get('lang') || localStorage.getItem('pref_lang') || 'en';
  const pParam = new URLSearchParams(window.location.search).get('p')
  let hubHref = environment.HUB_ENDPOINT + '?lang=' + lang;
  if (!!pParam) {
    hubHref += '&p=' + pParam;
  }
  window.location.href = hubHref;
} else {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}
